enum SUB_ORG {
  VIC,
  QLD,
  NSW,
}

const STATES = {
  VIC: SUB_ORG[SUB_ORG.VIC],
  TAS: SUB_ORG[SUB_ORG.VIC],
  SA: SUB_ORG[SUB_ORG.VIC],
  WA: SUB_ORG[SUB_ORG.VIC],

  QLD: SUB_ORG[SUB_ORG.QLD],
  NT: SUB_ORG[SUB_ORG.QLD],

  ACT: SUB_ORG[SUB_ORG.NSW],
  NSW: SUB_ORG[SUB_ORG.NSW],
};

export function getSubOrgByState(state: string) {
  return STATES[state];
}



// WEBPACK FOOTER //
// ./src/app/shared/sub-organisation.ts